// extracted by mini-css-extract-plugin
module.exports = {"container":"Design-module--container--24H1j"};